import { render, staticRenderFns } from "./Images.vue?vue&type=template&id=4bc5f674"
import script from "./Images.vue?vue&type=script&lang=js"
export * from "./Images.vue?vue&type=script&lang=js"
import style0 from "./Images.vue?vue&type=style&index=0&id=4bc5f674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports